import { render } from "./MerceariaPage.vue?vue&type=template&id=0dbc3176"
import script from "./MerceariaPage.vue?vue&type=script&lang=js"
export * from "./MerceariaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__